import apiRequest from './handler';

// The CSV arrives as a raw axios response rather than parsed JSON, which is
// what handler's last argument selects. Anchor-click is how the existing
// report download in LoanCardList saves a file, kept identical here.
const downloadEnquiryExport = async (filters, setIsAuthenticated, navigate) => {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined && value !== 'all') {
            query.append(key, value);
        }
    });

    const response = await apiRequest(
        `/reseller/enquiry-export?${query.toString()}`,
        'GET',
        null,
        true,
        setIsAuthenticated,
        navigate,
        true
    );

    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    // The backend names the file after the filters it applied and the moment
    // it ran, so the name is read off the response rather than invented here.
    // A cross-origin response only exposes the header when the server says so,
    // hence the fallback.
    const disposition = response.headers?.['content-disposition'] ?? '';
    const fileName = disposition.match(/filename=([^;]+)/)?.[1]?.trim()
        ?? 'optimo_enquiries.csv';

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export default downloadEnquiryExport;
